import { GrowthBook } from '@growthbook/growthbook-react'
import { CurrentEnvironment } from '~/shared/constants/commonConstants'
import { getCurrentEnv } from '~/shared/helpers/getCurrentEnv'

const PROD_GROWTHBOOK_CLIENT_KEY = 'sdk-soIGmMAYw1PELGCo'
const DEV_GROWTHBOOK_CLIENT_KEY = 'sdk-GD75rEigy6a2fV2v'

const clientKey =
  getCurrentEnv() === CurrentEnvironment.PROD
    ? PROD_GROWTHBOOK_CLIENT_KEY
    : DEV_GROWTHBOOK_CLIENT_KEY

export const growthBookInstance = new GrowthBook({
  enableDevMode: true,
  apiHost: 'https://cdn.growthbook.io',
  clientKey,
})

try {
  growthBookInstance.init({ streaming: true })
} catch (error) {
  console.error(`Error during growthBookInstance initialization: ${error}`)
}
